export const vakanties = {
  display: {
    xlarge: "var(--display-xlarge, 700 56px/110% var(--Lato))",
    large: "var(--display-large, 700 48px/110% var(--Lato))",
  },
  title: {
    h1: "var(--title-h1, 700 40px/110% var(--Montserrat))",
    h2: "var(--title-h2, 700 32px/110% var(--Montserrat))",
    h3: "var(--title-h3, 700 24px/110% var(--Montserrat))",
  },
  subtitle: {
    h4: "var(--subtitle-h4, 600 20px/110% var(--Montserrat))",
    h5: "var(--subtitle-h5, 600 18px/110% var(--Montserrat))",
    h6: "var(--subtitle-h6, 600 16px/110% var(--Montserrat))",
  },
  body: {
    large: "var(--body-large, 400 18px/120% var(--Lato))",
    medium: "var(--body-medium, 400 16px/120% var(--Lato))",
    small: "var(--body-small, 400 14px/120% var(--Lato))",
    color: {
      default: "var(--body-color-default, #000000)",
    },
    foreground: {
      color: {
        default: "var(--body-foreground-color-default, #4a4a4a)",
        dimmed: "var(--body-foreground-color-dimmed, #808080)",
        mandatory: "var(--body-foreground-color-mandatory, #e42626)",
      },
    },
    background: {
      color: {
        default: "var(--body-background-color-default, #ffffff)",
      },
    },
  },
  button: {
    focus: "var(--button-focus, 0px 0px 0px 2px rgba(251, 251, 251, 1), 0px 0px 0px 4px rgba(251, 214, 132, 1))",
    medium: "var(--button-medium, 600 16px/150% var(--Montserrat))",
    small: "var(--button-small, 600 14px/150% var(--Montserrat))",
    primary: {
      label: {
        color: {
          disabled: "var(--button-primary-label-color-disabled, #c28a04)",
          default: "var(--button-primary-label-color-default, #ffffff)",
          hover: "var(--button-primary-label-color-hover, #ffffff)",
          pressed: "var(--button-primary-label-color-pressed, #ffffff)",
          focus: "var(--button-primary-label-color-focus, #ffffff)",
        },
      },
      background: {
        color: {
          default: "var(--button-primary-background-color-default, #f3ad05)",
          hover: "var(--button-primary-background-color-hover, #c28a04)",
          pressed: "var(--button-primary-background-color-pressed, #926803)",
          focus: "var(--button-primary-background-color-focus, #f3ad05)",
          disabled: "var(--button-primary-background-color-disabled, #ededed)",
        },
      },
      border: {
        color: {
          default: "var(--button-primary-border-color-default, transparent)",
          hover: "var(--button-primary-border-color-hover, transparent)",
          pressed: "var(--button-primary-border-color-pressed, transparent)",
          focus: "var(--button-primary-border-color-focus, #ffc5a8)",
          disabled: "var(--button-primary-border-color-disabled, transparent)",
        },
      },
    },
    secondary: {
      background: {
        color: {
          default: "var(--button-secondary-background-color-default, #ededed)",
          hover: "var(--button-secondary-background-color-hover, #dbdbdb)",
          pressed: "var(--button-secondary-background-color-pressed, #c9c9c9)",
          focus: "var(--button-secondary-background-color-focus, #ededed)",
          disabled: "var(--button-secondary-background-color-disabled, #fbfbfb)",
        },
      },
      label: {
        color: {
          default: "var(--button-secondary-label-color-default, #4a4a4a)",
          hover: "var(--button-secondary-label-color-hover, #4a4a4a)",
          pressed: "var(--button-secondary-label-color-pressed, #4a4a4a)",
          focus: "var(--button-secondary-label-color-focus, #4a4a4a)",
          disabled: "var(--button-secondary-label-color-disabled, #808080)",
        },
      },
      border: {
        color: {
          default: "var(--button-secondary-border-color-default, transparent)",
          hover: "var(--button-secondary-border-color-hover, transparent)",
          pressed: "var(--button-secondary-border-color-pressed, transparent)",
          focus: "var(--button-secondary-border-color-focus, #fade9b)",
          disabled: "var(--button-secondary-border-color-disabled, transparent)",
        },
        default: "var(--button-secondary-border-default, 1px solid transparent)",
        hover: "var(--button-secondary-border-hover, 1px solid transparent)",
        pressed: "var(--button-secondary-border-pressed, 1px solid transparent)",
        focus: "var(--button-secondary-border-focus, 2px solid #fade9b)",
        disabled: "var(--button-secondary-border-disabled, 1px solid transparent)",
      },
    },
    tertiary: {
      background: {
        color: {
          default: "var(--button-tertiary-background-color-default, transparent)",
          hover: "var(--button-tertiary-background-color-hover, #ededed)",
          pressed: "var(--button-tertiary-background-color-pressed, #fade9b)",
          focus: "var(--button-tertiary-background-color-focus, #ffffff03)",
          disabled: "var(--button-tertiary-background-color-disabled, transparent)",
        },
      },
      label: {
        color: {
          default: "var(--button-tertiary-label-color-default, #4a4a4a)",
          hover: "var(--button-tertiary-label-color-hover, #4a4a4a)",
          pressed: "var(--button-tertiary-label-color-pressed, #926803)",
          focus: "var(--button-tertiary-label-color-focus, #4a4a4a)",
          disabled: "var(--button-tertiary-label-color-disabled, #a5a5a5)",
        },
      },
      button: {
        border: {
          default: "var(--button-tertiary-button-border-default, 2px solid transparent)",
          hover: "var(--button-tertiary-button-border-hover, 2px solid transparent)",
          pressed: "var(--button-tertiary-button-border-pressed, 2px solid transparent)",
          focus: "var(--button-tertiary-button-border-focus, 2px solid transparent)",
          disabled: "var(--button-tertiary-button-border-disabled, 2px solid transparent)",
        },
      },
    },
    height: {
      large: "var(--button-height-large, 56px)",
      medium: "var(--button-height-medium, 48px)",
      small: "var(--button-height-small, 40px)",
    },
    borderRadius: "var(--button-border-radius, 8px)",
    negative: {
      filled: {
        background: {
          color: {
            default: "var(--button-negative-filled-background-color-default, #e42626)",
            hover: "var(--button-negative-filled-background-color-hover, #b61e1e)",
            pressed: "var(--button-negative-filled-background-color-pressed, #891717)",
            focus: "var(--button-negative-filled-background-color-focus, #e42626)",
            disabled: "var(--button-negative-filled-background-color-disabled, #f4a8a8)",
          },
        },
        label: {
          color: {
            default: "var(--button-negative-filled-label-color-default, #ffffff)",
            hover: "var(--button-negative-filled-label-color-hover, #ffffff)",
            pressed: "var(--button-negative-filled-label-color-pressed, #ffffff)",
            focus: "var(--button-negative-filled-label-color-focus, #ffffff)",
            disabled: "var(--button-negative-filled-label-color-disabled, #891717)",
          },
        },
      },
      outline: {
        background: {
          color: {
            default: "var(--button-negative-outline-background-color-default, transparent)",
            hover: "var(--button-negative-outline-background-color-hover, transparent)",
            pressed: "var(--button-negative-outline-background-color-pressed, transparent)",
            focus: "var(--button-negative-outline-background-color-focus, #ffffff03)",
            disabled: "var(--button-negative-outline-background-color-disabled, transparent)",
          },
        },
        label: {
          color: {
            default: "var(--button-negative-outline-label-color-default, #e42626)",
            hover: "var(--button-negative-outline-label-color-hover, #b61e1e)",
            pressed: "var(--button-negative-outline-label-color-pressed, #891717)",
            focus: "var(--button-negative-outline-label-color-focus, #e42626)",
            disabled: "var(--button-negative-outline-label-color-disabled, #f4a8a8)",
          },
        },
        border: {
          color: {
            default: "var(--button-negative-outline-border-color-default, #e42626)",
            hover: "var(--button-negative-outline-border-color-hover, #b61e1e)",
            pressed: "var(--button-negative-outline-border-color-pressed, #891717)",
            focus: "var(--button-negative-outline-border-color-focus, #e42626)",
            disabled: "var(--button-negative-outline-border-color-disabled, #f4a8a8)",
          },
        },
      },
      border: {
        default: "var(--button-negative-border-default, 1px solid #e42626)",
        hover: "var(--button-negative-border-hover, 1px solid #b61e1e)",
        pressed: "var(--button-negative-border-pressed, 1px solid #891717)",
        focus: "var(--button-negative-border-focus, 1px solid #e42626)",
        disabled: "var(--button-negative-border-disabled, 1px solid #f4a8a8)",
      },
    },
    carouselControl: {
      background: {
        color: {
          default: "var(--button-carousel-control-background-color-default, #ededed)",
          hover: "var(--button-carousel-control-background-color-hover, #dbdbdb)",
          pressed: "var(--button-carousel-control-background-color-pressed, #c9c9c9)",
          focus: "var(--button-carousel-control-background-color-focus, #ededed)",
          disabled: "var(--button-carousel-control-background-color-disabled, #fbfbfb)",
        },
      },
      foreground: {
        default: "var(--button-carousel-control-foreground-default, #4a4a4a)",
        hover: "var(--button-carousel-control-foreground-hover, #4a4a4a)",
        pressed: "var(--button-carousel-control-foreground-pressed, #4a4a4a)",
        focus: "var(--button-carousel-control-foreground-focus, #4a4a4a)",
        disabled: "var(--button-carousel-control-foreground-disabled, #a5a5a5)",
      },
      border: {
        default: "var(--button-carousel-control-border-default, 1px solid #e42626)",
        hover: "var(--button-carousel-control-border-hover, 1px solid #b61e1e)",
        pressed: "var(--button-carousel-control-border-pressed, 1px solid #891717)",
        focus: "var(--button-carousel-control-border-focus, 1px solid #e42626)",
        disabled: "var(--button-carousel-control-border-disabled, 1px solid #f4a8a8)",
      },
    },
  },
  caption: {
    medium: "var(--caption-medium, 400 14px/150% var(--Lato))",
    small: "var(--caption-small, 400 12px/150% var(--Lato))",
  },
  label: {
    large: "var(--label-large, 600 18px/120% var(--Lato))",
    medium: "var(--label-medium, 600 14px/120% var(--Lato))",
    small: "var(--label-small, 600 12px/150% var(--Lato))",
  },
  borderRadius: {
    pill: "var(--border-radius-pill, 50%)",
    rounded: "var(--border-radius-rounded, 8px)",
    extraRound: "var(--border-radius-extra-round, 16px)",
    rounder: "var(--border-radius-rounder, 8px)",
    squared: "var(--border-radius-squared, 0px)",
    circle: "var(--border-radius-circle, 50%)",
  },
  brand: {
    color: {
      default: "var(--brand-color-default, #f3ad05)",
      hover: "var(--brand-color-hover, #c28a04)",
      pressed: "var(--brand-color-pressed, #926803)",
      focus: "var(--brand-color-focus, #f3ad05)",
      disabled: "var(--brand-color-disabled, #fade9b)",
    },
  },
  fontFamily: {
    primary: "var(--font-family-primary, var(--Lato))",
    secondary: "var(--font-family-secondary, var(--Montserrat))",
  },
  primary: {
    color: {
      default: "var(--primary-color-default, #3d9b8b)",
      hover: "var(--primary-color-hover, #317c6f)",
      pressed: "var(--primary-color-pressed, #255d53)",
      focus: "var(--primary-color-focus, #3d9b8b)",
      disabled: "var(--primary-color-disabled, #b1d7d1)",
    },
  },
  flightSelection: {
    focus: "var(--flight-selection-focus, 0px 0px 0px 2px rgba(251, 251, 251, 1), 0px 0px 0px 4px rgba(251, 214, 132, 1))",
    timestamp: {
      font: "var(--flight-selection-timestamp-font, 600 16px/150% var(--Lato))",
      color: "var(--flight-selection-timestamp-color, #4a4a4a)",
    },
    stops: {
      font: "var(--flight-selection-stops-font, 600 14px/150% var(--Lato))",
      color: {
        direct: "var(--flight-selection-stops-color-direct, #028e00)",
        transfer: "var(--flight-selection-stops-color-transfer, #ff6f26)",
      },
    },
    travelTime: {
      font: "var(--flight-selection-travel-time-font, 400 14px/150% var(--Lato))",
      color: "var(--flight-selection-travel-time-color, #a5a5a5)",
    },
    airport: {
      color: "var(--flight-selection-airport-color, #4a4a4a)",
      font: "var(--flight-selection-airport-font, 400 14px/150% var(--Lato))",
    },
    airline: {
      color: "var(--flight-selection-airline-color, #808080)",
    },
    airliner: {
      font: "var(--flight-selection-airliner-font, 400 14px/150% var(--Lato))",
    },
    background: {
      color: "var(--flight-selection-background-color, #ffffff)",
    },
    border: {
      default: "var(--flight-selection-border-default, 1px solid #dbdbdb)",
      hover: "var(--flight-selection-border-hover, 1px solid #a5a5a5)",
      focus: "var(--flight-selection-border-focus, 1px solid #dbdbdb)",
      selected: "var(--flight-selection-border-selected, 2px solid #f3ad05)",
    },
    borderRadius: "var(--flight-selection-border-radius, 8px)",
    info: {
      color: "var(--flight-selection-info-color, #808080)",
    },
  },
  pointer: {
    focus: "var(--pointer-focus, 0px 0px 0px 1px rgba(251, 251, 251, 1), 0px 0px 0px 2px rgba(251, 214, 132, 1))",
    shadow: {
      color: "var(--pointer-shadow-color, #f3ad0566)",
    },
    background: {
      color: {
        active: "var(--pointer-background-color-active, #f3ad05)",
        inactive: "var(--pointer-background-color-inactive, #f9c95b)",
      },
    },
    foreground: {
      color: "var(--pointer-foreground-color, #ffffff)",
    },
    size: {
      active: "var(--pointer-size-active, 56rem)",
      inactive: "var(--pointer-size-inactive, 40rem)",
    },
  },
  radio: {
    focus: "var(--radio-focus, 0px 0px 0px 2px rgba(255, 255, 255, 1), 0px 0px 0px 4px rgba(251, 214, 132, 1))",
    size: "var(--radio-size, 24px)",
    unselected: {
      background: {
        color: {
          default: "var(--radio-unselected-background-color-default, #ededed)",
          hover: "var(--radio-unselected-background-color-hover, #dbdbdb)",
          pressed: "var(--radio-unselected-background-color-pressed, #c9c9c9)",
          focus: "var(--radio-unselected-background-color-focus, #ededed)",
          disabled: "var(--radio-unselected-background-color-disabled, #ededed)",
        },
      },
      border: {
        color: {
          default: "var(--radio-unselected-border-color-default, #a5a5a5)",
          hover: "var(--radio-unselected-border-color-hover, #808080)",
          pressed: "var(--radio-unselected-border-color-pressed, #4a4a4a)",
          focus: "var(--radio-unselected-border-color-focus, #a5a5a5)",
          disabled: "var(--radio-unselected-border-color-disabled, #dbdbdb)",
        },
      },
    },
    selected: {
      background: {
        color: {
          default: "var(--radio-selected-background-color-default, #f3ad05)",
          hover: "var(--radio-selected-background-color-hover, #c28a04)",
          pressed: "var(--radio-selected-background-color-pressed, #926803)",
          focus: "var(--radio-selected-background-color-focus, #f3ad05)",
          disabled: "var(--radio-selected-background-color-disabled, #fade9b)",
        },
      },
      foreground: {
        color: {
          default: "var(--radio-selected-foreground-color-default, #ffffff)",
          disabled: "var(--radio-selected-foreground-color-disabled, #cc591e)",
        },
      },
    },
    border: {
      unselected: {
        default: "var(--radio-border-unselected-default, 2px solid #a5a5a5)",
        hover: "var(--radio-border-unselected-hover, 2px solid #808080)",
        pressed: "var(--radio-border-unselected-pressed, 2px solid #4a4a4a)",
        focus: "var(--radio-border-unselected-focus, 2px solid #a5a5a5)",
        disabled: "var(--radio-border-unselected-disabled, 2px solid #dbdbdb)",
      },
    },
  },
  checkbox: {
    focus: "var(--checkbox-focus, 0px 0px 0px 2px rgba(255, 255, 255, 1), 0px 0px 0px 4px rgba(251, 214, 132, 1))",
    size: "var(--checkbox-size, 24px)",
    unselected: {
      background: {
        color: {
          default: "var(--checkbox-unselected-background-color-default, #ededed)",
          hover: "var(--checkbox-unselected-background-color-hover, #dbdbdb)",
          pressed: "var(--checkbox-unselected-background-color-pressed, #c9c9c9)",
          focus: "var(--checkbox-unselected-background-color-focus, #ededed)",
          disabled: "var(--checkbox-unselected-background-color-disabled, #ededed)",
        },
      },
      border: {
        color: {
          default: "var(--checkbox-unselected-border-color-default, #a5a5a5)",
          hover: "var(--checkbox-unselected-border-color-hover, #808080)",
          pressed: "var(--checkbox-unselected-border-color-pressed, #4a4a4a)",
          focus: "var(--checkbox-unselected-border-color-focus, #a5a5a5)",
          disabled: "var(--checkbox-unselected-border-color-disabled, #dbdbdb)",
        },
      },
    },
    selected: {
      background: {
        color: {
          default: "var(--checkbox-selected-background-color-default, #f3ad05)",
          hover: "var(--checkbox-selected-background-color-hover, #c28a04)",
          pressed: "var(--checkbox-selected-background-color-pressed, #926803)",
          focus: "var(--checkbox-selected-background-color-focus, #f3ad05)",
          disabled: "var(--checkbox-selected-background-color-disabled, #fade9b)",
        },
      },
      foreground: {
        color: {
          default: "var(--checkbox-selected-foreground-color-default, #ffffff)",
          disabled: "var(--checkbox-selected-foreground-color-disabled, #cc591e)",
        },
      },
    },
    borderRadius: "var(--checkbox-border-radius, 8px)",
    border: {
      unselected: {
        default: "var(--checkbox-border-unselected-default, 2px solid #a5a5a5)",
        hover: "var(--checkbox-border-unselected-hover, 2px solid #808080)",
        pressed: "var(--checkbox-border-unselected-pressed, 2px solid #4a4a4a)",
        focus: "var(--checkbox-border-unselected-focus, 2px solid #a5a5a5)",
        disabled: "var(--checkbox-border-unselected-disabled, 2px solid #dbdbdb)",
      },
    },
  },
  input: {
    focus: "var(--input-focus, 0px 0px 0px 2px rgba(251, 251, 251, 1), 0px 0px 0px 4px rgba(251, 214, 132, 1))",
    background: {
      color: {
        default: "var(--input-background-color-default, #ffffff)",
        disabled: "var(--input-background-color-disabled, #ededed)",
      },
    },
    borderRadius: "var(--input-border-radius, 8px)",
    border: {
      default: "var(--input-border-default, 1px solid #a5a5a5)",
      hover: "var(--input-border-hover, 1px solid #808080)",
      pressed: "var(--input-border-pressed, 1px solid #4a4a4a)",
      focus: "var(--input-border-focus, 1px solid #a5a5a5)",
      disabled: "var(--input-border-disabled, 1px solid #0000004d)",
      error: "var(--input-border-error, 1px solid #e42626)",
      color: {
        default: "var(--input-border-color-default, #a5a5a5)",
        hover: "var(--input-border-color-hover, #808080)",
        pressed: "var(--input-border-color-pressed, #4a4a4a)",
        focus: "var(--input-border-color-focus, #a5a5a5)",
        disabled: "var(--input-border-color-disabled, transparent)",
        error: "var(--input-border-color-error, #e42626)",
      },
    },
    height: {
      large: "var(--input-height-large, 56px)",
      medium: "var(--input-height-medium, 48px)",
      small: "var(--input-height-small, 40px)",
    },
    label: {
      color: "var(--input-label-color, #4a4a4a)",
    },
    foreground: {
      empty: {
        color: "var(--input-foreground-empty-color, #808080)",
      },
      filled: {
        color: "var(--input-foreground-filled-color, #4a4a4a)",
      },
      negative: {
        color: "var(--input-foreground-negative-color, #e42626)",
      },
      positive: {
        color: "var(--input-foreground-positive-color, #1dab33)",
      },
    },
    prefix: {
      color: "var(--input-prefix-color, #808080)",
    },
    message: {
      color: {
        negative: "var(--input-message-color-negative, #e42626)",
        default: "var(--input-message-color-default, #808080)",
      },
    },
  },
  select: {
    focus: "var(--select-focus, 0px 0px 0px 2px rgba(251, 251, 251, 1), 0px 0px 0px 4px rgba(251, 214, 132, 1))",
  },
  heading: {
    color: "var(--heading-color, #3d9b8b)",
  },
  topbar: {
    background: {
      color: "var(--topbar-background-color, #3d9b8b)",
    },
    foreground: {
      color: "var(--topbar-foreground-color, #ffffff)",
    },
    height: {
      desktop: "var(--topbar-height-desktop, 40px)",
      mobile: "var(--topbar-height-mobile, 32px)",
    },
  },
  calendar: {
    cell: {
      background: {
        selected: "var(--calendar-cell-background-selected, #fbd684)",
        selectedHover: "var(--calendar-cell-background-selected-hover, #f9c95b)",
        selectedDimmed: "var(--calendar-cell-background-selected-dimmed, #fbd68480)",
        default: "var(--calendar-cell-background-default, transparent)",
        hover: "var(--calendar-cell-background-hover, #ededed)",
        week: "var(--calendar-cell-background-week, #fbfbfb)",
        selectedDimmedCopy: "var(--calendar-cell-background-selected-dimmed-copy, #ffc5a880)",
      },
      foreground: {
        selected: "var(--calendar-cell-foreground-selected, #95701e)",
        current: "var(--calendar-cell-foreground-current, #f8bb32)",
        default: "var(--calendar-cell-foreground-default, #4a4a4a)",
        inactive: "var(--calendar-cell-foreground-inactive, #a5a5a5)",
        hover: "var(--calendar-cell-foreground-hover, #4a4a4a)",
      },
      border: {
        color: {
          selected: "var(--calendar-cell-border-color-selected, #fbd684)",
          default: "var(--calendar-cell-border-color-default, transparent)",
        },
        selected: "var(--calendar-cell-border-selected, 2px dashed #fbd684)",
      },
      default: {
        font: "var(--calendar-cell-default-font, 400 16px/150% var(--Lato))",
      },
      selected: {
        font: "var(--calendar-cell-selected-font, 600 16px/150% var(--Lato))",
      },
    },
    head: {
      font: "var(--calendar-head-font, 600 14px/150% var(--Lato))",
    },
  },
  secondary: {
    color: {
      default: "var(--secondary-color-default, #f8bb32)",
      hover: "var(--secondary-color-hover, #c69628)",
      pressed: "var(--secondary-color-pressed, #95701e)",
      focus: "var(--secondary-color-focus, #f8bb32)",
      disabled: "var(--secondary-color-disabled, #fbd684)",
    },
  },
  tertiary: {
    color: {
      default: "var(--tertiary-color-default, #b148aa)",
      hover: "var(--tertiary-color-hover, #8e3a88)",
      pressed: "var(--tertiary-color-pressed, #6a2b66)",
      focus: "var(--tertiary-color-focus, #b148aa)",
      disabled: "var(--tertiary-color-disabled, #e0b6dd)",
    },
  },
  link: {
    color: {
      light: {
        default: "var(--link-color-light-default, #4a4a4a)",
        hover: "var(--link-color-light-hover, #ff6f26)",
        pressed: "var(--link-color-light-pressed, #cc591e)",
        focus: "var(--link-color-light-focus, #ff6f26)",
      },
      dark: {
        default: "var(--link-color-dark-default, #ffffff)",
        hover: "var(--link-color-dark-hover, #ff6f26)",
        pressed: "var(--link-color-dark-pressed, #cc591e)",
        focus: "var(--link-color-dark-focus, #ffffff)",
      },
    },
  },
  navbar: {
    border: "var(--navbar-border, 1px solid #dbdbdb)",
    elevation: "var(--navbar-elevation, 0px 6px 8px 0px rgba(0, 0, 0, 0.1))",
    list: {
      listItem: {
        color: {
          default: "var(--navbar-list-list-item-color-default, #4a4a4a)",
          hover: "var(--navbar-list-list-item-color-hover, #ff6f26)",
        },
      },
      listTitle: {
        color: {
          default: "var(--navbar-list-list-title-color-default, #2c2c2c)",
        },
      },
    },
    background: {
      color: "var(--navbar-background-color, #ffffff)",
    },
    height: "var(--navbar-height, 72px)",
  },
  elevation: {
    color: "var(--elevation-color, #0000001a)",
    top: {
      base: "var(--elevation-top-base, none)",
      lifted: "var(--elevation-top-lifted, 0px 1px 4px 0px rgba(0, 0, 0, 0.1))",
      raised: "var(--elevation-top-raised, 0px 6px 8px 0px rgba(0, 0, 0, 0.1))",
      floating: "var(--elevation-top-floating, 0px 8px 32px 0px rgba(0, 0, 0, 0.1))",
    },
    opacity: "var(--elevation-opacity, 10%)",
    down: {
      base: "var(--elevation-down-base, none)",
      lifted: "var(--elevation-down-lifted, 0px -1px 4px 0px rgba(0, 0, 0, 0.1))",
      raised: "var(--elevation-down-raised, 0px -6px 8px 0px rgba(0, 0, 0, 0.1))",
      floating: "var(--elevation-down-floating, 0px -8px 32px 0px rgba(0, 0, 0, 0.1))",
    },
    left: {
      base: "var(--elevation-left-base, none)",
      lifted: "var(--elevation-left-lifted, -1px 0px 4px 0px rgba(0, 0, 0, 0.1))",
      raised: "var(--elevation-left-raised, -6px 0px 8px 0px rgba(0, 0, 0, 0.1))",
      floating: "var(--elevation-left-floating, -8px 0px 32px 0px rgba(0, 0, 0, 0.1))",
    },
    right: {
      base: "var(--elevation-right-base, none)",
      lifted: "var(--elevation-right-lifted, 1px 0px 4px 0px rgba(0, 0, 0, 0.1))",
      raised: "var(--elevation-right-raised, 6px 0px 8px 0px rgba(0, 0, 0, 0.1))",
      floating: "var(--elevation-right-floating, 8px 0px 32px 0px rgba(0, 0, 0, 0.1))",
    },
  },
  quickSearch: {
    location: "var(--quick-search-location, 400 14px/150% var(--Lato))",
    color: "var(--quick-search-color, #a5a5a5)",
    place: {
      default: "var(--quick-search-place-default, 400 16px/150% var(--Lato))",
      match: "var(--quick-search-place-match, 700 16px/150% var(--Lato))",
    },
  },
  avatar: {
    background: {
      color: "var(--avatar-background-color, #ffe2d4)",
    },
    size: {
      jumbo: "var(--avatar-size-jumbo, 96px)",
      large: "var(--avatar-size-large, 56px)",
      medium: "var(--avatar-size-medium, 40px)",
      small: "var(--avatar-size-small, 32px)",
      xsmall: "var(--avatar-size-xsmall, 24px)",
    },
    borderRadius: {
      rounded: "var(--avatar-border-radius-rounded, 8px)",
      circle: "var(--avatar-border-radius-circle, 50%)",
    },
  },
  card: {
    priceCaption: {
      default: "var(--card-price-caption-default, 600 12px/120% var(--Lato))",
      original: "var(--original, {weight.semibold} {font-size.tiny}/{line-height.default} {font-family.primary})",
    },
    offerPrice: {
      md: "var(--card-offer-price-md, 700 32px/120% var(--Lato))",
    },
    foreground: {
      color: {
        geo: "var(--card-foreground-color-geo, #808080)",
        dark: "var(--card-foreground-color-dark, #1e1e1e)",
        light: "var(--card-foreground-color-light, #ffffff)",
        deal: "var(--card-foreground-color-deal, #ff6f26)",
        dimmed: "var(--card-foreground-color-dimmed, #808080)",
        default: "var(--card-foreground-color-default, #4a4a4a)",
      },
    },
    background: {
      color: {
        light: "var(--card-background-color-light, #ffffff)",
      },
    },
    priceBefore: {
      md: "var(--card-price-before-md, 600 12px/120% var(--Lato))",
    },
    geo: {
      font: "var(--card-geo-font, 600 16px/150% var(--Lato))",
    },
    gradient: {
      start: "var(--card-gradient-start, #00000080)",
      end: "var(--card-gradient-end, #00000000)",
    },
  },
  rating: {
    color: "var(--rating-color, #f8bb32)",
  },
  priceBar: {
    background: {
      default: "var(--price-bar-background-default, #fef1d6)",
      hover: "var(--price-bar-background-hover, #fbd684)",
      selected: {
        default: "var(--price-bar-background-selected-default, #f3ad05)",
        hover: "var(--price-bar-background-selected-hover, #c28a04)",
      },
      lowest: {
        default: "var(--price-bar-background-lowest-default, #d8ebe8)",
        hover: "var(--price-bar-background-lowest-hover, #b1d7d1)",
      },
    },
    foreground: {
      default: "var(--price-bar-foreground-default, #4a4a4a)",
      selected: "var(--price-bar-foreground-selected, #ffffff)",
      deal: "var(--price-bar-foreground-deal, #ffffff)",
    },
    column: {
      background: {
        default: "var(--price-bar-column-background-default, transparent)",
        hover: "var(--price-bar-column-background-hover, #fbfbfb)",
      },
    },
    duration: {
      md: "var(--price-bar-duration-md, 600 16px/150% var(--Lato))",
      sm: "var(--price-bar-duration-sm, 600 12px/150% var(--Lato))",
    },
    price: {
      md: "var(--price-bar-price-md, 700 20px/110% var(--Lato))",
      sm: "var(--price-bar-price-sm, 700 18px/110% var(--Lato))",
    },
    caption: {
      md: "var(--price-bar-caption-md, 400 14px/150% var(--Lato))",
      sm: "var(--price-bar-caption-sm, 400 12px/150% var(--Lato))",
    },
    date: {
      md: "var(--price-bar-date-md, 700 16px/120% var(--Lato))",
      sm: "var(--price-bar-date-sm, 700 14px/120% var(--Lato))",
    },
    width: {
      md: "var(--price-bar-width-md, 104px)",
      sm: "var(--price-bar-width-sm, 56px)",
    },
  },
  priceBlock: {
    price: {
      md: "var(--price-block-price-md, 700 56px/110% var(--Lato))",
      sm: "var(--price-block-price-sm, 700 24px/110% var(--Lato))",
      color: "var(--price-block-price-color, #3d9b8b)",
    },
    priceBefore: {
      font: "var(--price-block-price-before-font, 700 24px/120% var(--Lato))",
      color: "var(--price-block-price-before-color, #a5a5a5)",
    },
    originalPrice: {
      color: "var(--price-block-original-price-color, #a5a5a5)",
    },
    border: {
      default: "var(--price-block-border-default, 1px solid #dbdbdb)",
    },
  },
  userScore: {
    color: {
      none: "var(--user-score-color-none, #dbdbdb)",
      bad: "var(--user-score-color-bad, #b8173d)",
      mediocre: "var(--user-score-color-mediocre, #f8ce69)",
      good: "var(--user-score-color-good, #02b200)",
      great: "var(--user-score-color-great, #028e00)",
    },
    foreground: {
      color: {
        default: "var(--user-score-foreground-color-default, #ffffff)",
        none: "var(--user-score-foreground-color-none, #4a4a4a)",
        mediocre: "var(--user-score-foreground-color-mediocre, #614502)",
      },
    },
    label: {
      jumbo: "var(--user-score-label-jumbo, 700 40px/150% var(--Lato))",
      large: "var(--user-score-label-large, 700 24px/150% var(--Lato))",
      medium: "var(--user-score-label-medium, 700 20px/150% var(--Lato))",
      small: "var(--user-score-label-small, 700 18px/150% var(--Lato))",
      xSmall: "var(--user-score-label-x-small, 700 16px/150% var(--Lato))",
    },
  },
  breadCrumb: {
    link: {
      default: "var(--bread-crumb-link-default, 600 14px/150% var(--Lato))",
      hover: "var(--bread-crumb-link-hover, 600 14px/150% var(--Lato))",
      color: {
        default: "var(--bread-crumb-link-color-default, #4a4a4a)",
        hover: "var(--bread-crumb-link-color-hover, #ff6f26)",
      },
    },
    current: {
      default: "var(--bread-crumb-current-default, 400 14px/120% var(--Lato))",
      color: {
        default: "var(--bread-crumb-current-color-default, #808080)",
      },
    },
    separation: {
      color: "var(--bread-crumb-separation-color, #c9c9c9)",
    },
  },
  tag: {
    rounded: "var(--tag-rounded, 8px)",
    pill: "var(--tag-pill, 50%)",
    default: "var(--tag-default, 700 14px/150% var(--Lato))",
    small: "var(--tag-small, 700 12px/150% var(--Lato))",
    orange: {
      filled: {
        background: {
          color: "var(--tag-orange-filled-background-color, #ffe2d4)",
        },
        foreground: {
          color: "var(--tag-orange-filled-foreground-color, #994317)",
        },
      },
      outline: {
        background: {
          color: "var(--tag-orange-outline-background-color, transparent)",
        },
        foreground: {
          color: "var(--tag-orange-outline-foreground-color, #ff6f26)",
        },
        border: {
          color: "var(--tag-orange-outline-border-color, #ff6f26)",
        },
      },
    },
    teal: {
      filled: {
        background: {
          color: "var(--tag-teal-filled-background-color, #d8ebe8)",
        },
        foreground: {
          color: "var(--tag-teal-filled-foreground-color, #255d53)",
        },
      },
      outline: {
        background: {
          color: "var(--tag-teal-outline-background-color, transparent)",
        },
        foreground: {
          color: "var(--tag-teal-outline-foreground-color, #3d9b8b)",
        },
        border: {
          color: "var(--tag-teal-outline-border-color, #3d9b8b)",
        },
      },
    },
    purple: {
      filled: {
        background: {
          color: "var(--tag-purple-filled-background-color, #efdaee)",
        },
        foreground: {
          color: "var(--tag-purple-filled-foreground-color, #6a2b66)",
        },
      },
      outline: {
        background: {
          color: "var(--tag-purple-outline-background-color, transparent)",
        },
        foreground: {
          color: "var(--tag-purple-outline-foreground-color, #b148aa)",
        },
        border: {
          color: "var(--tag-purple-outline-border-color, #b148aa)",
        },
      },
    },
    border: {
      outline: {
        orange: "var(--tag-border-outline-orange, 2px solid #ff6f26)",
        teal: "var(--tag-border-outline-teal, 2px solid #3d9b8b)",
        purple: "var(--tag-border-outline-purple, 2px solid #b148aa)",
        black: "var(--tag-border-outline-black, 2px solid #000000)",
        white: "var(--tag-border-outline-white, 2px solid #ffffff)",
        yellow: "var(--tag-border-outline-yellow, 2px solid #f8bb32)",
        gold: "var(--tag-border-outline-gold, 2px solid #95701e)",
        silver: "var(--tag-border-outline-silver, 2px solid #808080)",
      },
    },
    size: {
      medium: "var(--tag-size-medium, 32px)",
      small: "var(--tag-size-small, 24px)",
    },
    black: {
      filled: {
        background: {
          color: "var(--tag-black-filled-background-color, #00000099)",
        },
        foreground: {
          color: "var(--tag-black-filled-foreground-color, #ffffff)",
        },
      },
      outline: {
        background: {
          color: "var(--tag-black-outline-background-color, transparent)",
        },
        foreground: {
          color: "var(--tag-black-outline-foreground-color, #000000)",
        },
        border: {
          color: "var(--tag-black-outline-border-color, #000000)",
        },
      },
    },
    gold: {
      filled: {
        background: {
          color: "var(--tag-gold-filled-background-color, #fbd684)",
        },
        foreground: {
          color: "var(--tag-gold-filled-foreground-color, #95701e)",
        },
      },
      outline: {
        background: {
          color: "var(--tag-gold-outline-background-color, transparent)",
        },
        foreground: {
          color: "var(--tag-gold-outline-foreground-color, #95701e)",
        },
        border: {
          color: "var(--tag-gold-outline-border-color, #95701e)",
        },
      },
    },
    silver: {
      filled: {
        background: {
          color: "var(--tag-silver-filled-background-color, #ededed)",
        },
        foreground: {
          color: "var(--tag-silver-filled-foreground-color, #808080)",
        },
      },
      outline: {
        background: {
          color: "var(--tag-silver-outline-background-color, transparent)",
        },
        foreground: {
          color: "var(--tag-silver-outline-foreground-color, #808080)",
        },
        border: {
          color: "var(--tag-silver-outline-border-color, #808080)",
        },
      },
    },
    white: {
      filled: {
        background: {
          color: "var(--tag-white-filled-background-color, #ffffff)",
        },
        foreground: {
          color: "var(--tag-white-filled-foreground-color, #4a4a4a)",
        },
      },
      outline: {
        background: {
          color: "var(--tag-white-outline-background-color, transparent)",
        },
        foreground: {
          color: "var(--tag-white-outline-foreground-color, #ffffff)",
        },
        border: {
          color: "var(--tag-white-outline-border-color, #ffffff)",
        },
      },
    },
    yellow: {
      filled: {
        background: {
          color: "var(--tag-yellow-filled-background-color, #f8bb32)",
        },
        foreground: {
          color: "var(--tag-yellow-filled-foreground-color, #ffffff)",
        },
      },
      outline: {
        background: {
          color: "var(--tag-yellow-outline-background-color, transparent)",
        },
        foreground: {
          color: "var(--tag-yellow-outline-foreground-color, #f8bb32)",
        },
        border: {
          color: "var(--tag-yellow-outline-border-color, #f8bb32)",
        },
      },
    },
    whiteAlt: {
      filled: {
        background: {
          color: "var(--tag-white-alt-filled-background-color, #ffffff)",
        },
        foreground: {
          color: "var(--tag-white-alt-filled-foreground-color, #f8bb32)",
        },
      },
    },
    red: {
      filled: {
        background: {
          color: "var(--tag-red-filled-background-color, #fad4d4)",
        },
        foreground: {
          color: "var(--tag-red-filled-foreground-color, #891717)",
        },
      },
      outline: {
        background: {
          color: "var(--tag-red-outline-background-color, transparent)",
        },
        foreground: {
          color: "var(--tag-red-outline-foreground-color, #e42626)",
        },
        border: {
          color: "var(--tag-red-outline-border-color, #e42626)",
        },
      },
    },
    green: {
      filled: {
        background: {
          color: "var(--tag-green-filled-background-color, #d2eed6)",
        },
        foreground: {
          color: "var(--tag-green-filled-foreground-color, #11671f)",
        },
      },
      outline: {
        background: {
          color: "var(--tag-green-outline-background-color, transparent)",
        },
        foreground: {
          color: "var(--tag-green-outline-foreground-color, #1dab33)",
        },
        border: {
          color: "var(--tag-green-outline-border-color, #1dab33)",
        },
      },
    },
    blue: {
      filled: {
        background: {
          color: "var(--tag-blue-filled-background-color, #d4f0ff)",
        },
        foreground: {
          color: "var(--tag-blue-filled-foreground-color, #176d99)",
        },
      },
      outline: {
        background: {
          color: "var(--tag-blue-outline-background-color, transparent)",
        },
        foreground: {
          color: "var(--tag-blue-outline-foreground-color, #26b6ff)",
        },
        border: {
          color: "var(--tag-blue-outline-border-color, #26b6ff)",
        },
      },
    },
  },
  footer: {
    background: {
      color: "var(--footer-background-color, #ff6f26)",
    },
    foreground: {
      color: {
        default: "var(--footer-foreground-color-default, #ffe2d4)",
        hover: "var(--footer-foreground-color-hover, #ffffff)",
        title: "var(--footer-foreground-color-title, #ffffff)",
      },
    },
    title: "var(--footer-title, 700 16px/150% var(--Lato))",
    listItem: "var(--footer-list-item, 400 14px/150% var(--Lato))",
  },
  flashDeal: {
    background: {
      color: "var(--flash-deal-background-color, #f8bb32)",
    },
    foreground: {
      color: "var(--flash-deal-foreground-color, #ffffff)",
    },
  },
  review: {
    title: {
      font: "var(--review-title-font, 600 16px/110% var(--Lato))",
      color: "var(--review-title-color, #2c2c2c)",
    },
    body: {
      font: "var(--review-body-font, 400 14px/150% var(--Lato))",
      color: "var(--review-body-color, #4a4a4a)",
    },
    info: "var(--review-info, 400 14px/150% var(--Lato))",
    heading: {
      color: "var(--review-heading-color, #2c2c2c)",
    },
    foreground: {
      color: {
        dimmed: "var(--review-foreground-color-dimmed, #808080)",
        default: "var(--review-foreground-color-default, #4a4a4a)",
      },
    },
    background: {
      color: "var(--review-background-color, #ffffff)",
    },
    elevation: "var(--review-elevation, 0px 1px 4px 0px rgba(0, 0, 0, 0.1))",
    response: {
      border: "var(--review-response-border, 4px solid #ededed)",
    },
    section: {
      heading: {
        color: {
          default: "var(--review-section-heading-color-default, #634b14)",
          dimmed: "var(--review-section-heading-color-dimmed, #95701e)",
        },
      },
    },
  },
  accoTop: {
    seperation: {
      color: "var(--acco-top-seperation-color, #c9c9c9)",
    },
    link: {
      color: {
        default: "var(--acco-top-link-color-default, #808080)",
        hover: "var(--acco-top-link-color-hover, #ff6f26)",
        pressed: "var(--acco-top-link-color-pressed, #cc591e)",
        focus: "var(--acco-top-link-color-focus, #ff6f26)",
      },
    },
  },
  textSeperators: "var(--text-seperators, 400 14px/150% var(--Lato))",
  pageTitle: {
    md: "var(--page-title-md, 700 40px/110% var(--Lato))",
    sm: "var(--page-title-sm, 700 32px/110% var(--Lato))",
  },
  icon: {
    size: {
      xLarge: "var(--icon-size-x-large, 40px)",
      large: "var(--icon-size-large, 32px)",
      medium: "var(--icon-size-medium, 24px)",
      small: "var(--icon-size-small, 20px)",
      xSmall: "var(--icon-size-x-small, 16px)",
    },
  },
  quicknav: {
    input: "var(--quicknav-input, 400 18px/120% var(--Lato))",
  },
  modal: {
    elevation: "var(--modal-elevation, 0px 8px 32px 0px rgba(0, 0, 0, 0.1))",
    background: {
      color: "var(--modal-background-color, #ffffff)",
    },
    foreground: {
      color: "var(--modal-foreground-color, #4a4a4a)",
    },
    title: {
      color: "var(--modal-title-color, #3d9b8b)",
    },
    width: {
      full: "var(--modal-width-full, 100%)",
      large: "var(--modal-width-large, 792px)",
      medium: "var(--modal-width-medium, 520px)",
      small: "var(--modal-width-small, 400px)",
    },
    borderRadius: "var(--modal-border-radius, 8px)",
    topBar: {
      height: {
        default: "var(--modal-top-bar-height-default, 96px)",
        fullScreen: {
          mobile: "var(--modal-top-bar-height-full-screen-mobile, 56px)",
          desktop: "var(--modal-top-bar-height-full-screen-desktop, 80px)",
        },
      },
    },
  },
  dropdown: {
    listItem: {
      color: {
        default: "var(--dropdown-list-item-color-default, #4a4a4a)",
        hover: "var(--dropdown-list-item-color-hover, #ff6f26)",
        selected: "var(--dropdown-list-item-color-selected, #ff6f26)",
        dimmed: "var(--dropdown-list-item-color-dimmed, #808080)",
      },
      background: {
        color: {
          hover: "var(--dropdown-list-item-background-color-hover, #fbfbfb)",
        },
      },
    },
    sectionTitle: {
      color: "var(--dropdown-section-title-color, #808080)",
    },
    background: {
      color: {
        default: "var(--dropdown-background-color-default, #ffffff)",
      },
    },
    border: {
      color: {
        default: "var(--dropdown-border-color-default, #ededed)",
      },
    },
  },
  positive: {
    color: {
      default: "var(--positive-color-default, #1dab33)",
      hover: "var(--positive-color-hover, #178929)",
      pressed: "var(--positive-color-pressed, #11671f)",
      focus: "var(--positive-color-focus, #1dab33)",
      disabled: "var(--positive-color-disabled, #77cd85)",
    },
  },
  negative: {
    color: {
      default: "var(--negative-color-default, #e42626)",
      hover: "var(--negative-color-hover, #b61e1e)",
      pressed: "var(--negative-color-pressed, #891717)",
      focus: "var(--negative-color-focus, #e42626)",
      disabled: "var(--negative-color-disabled, #f4a8a8)",
    },
  },
  neutral: {
    color: {
      default: "var(--neutral-color-default, #26b6ff)",
      hover: "var(--neutral-color-hover, #1e92cc)",
      pressed: "var(--neutral-color-pressed, #176d99)",
      focus: "var(--neutral-color-focus, #26b6ff)",
      disabled: "var(--neutral-color-disabled, #7dd3ff)",
    },
  },
  caution: {
    color: {
      default: "var(--caution-color-default, #f8bb32)",
      hover: "var(--caution-color-hover, #c69628)",
      pressed: "var(--caution-color-pressed, #95701e)",
      focus: "var(--caution-color-focus, #f8bb32)",
      disabled: "var(--caution-color-disabled, #fbd684)",
    },
  },
  curtain: {
    color: "var(--curtain-color, #1e1e1e66)",
  },
  divider: {
    color: "var(--divider-color, #dbdbdb)",
    border: "var(--divider-border, 1px solid #dbdbdb)",
  },
  table: {
    border: "var(--table-border, 1px solid #dbdbdb)",
    cell: {
      default: {
        font: "var(--table-cell-default-font, 400 14px/150% var(--Lato))",
      },
      head: {
        font: "var(--table-cell-head-font, 600 16px/150% var(--Lato))",
      },
      foreground: {
        color: {
          color: "var(--table-cell-foreground-color-color, #4a4a4a)",
        },
      },
      background: {
        color: {
          even: "var(--table-cell-background-color-even, #ffffff)",
          uneven: "var(--table-cell-background-color-uneven, #fbfbfb)",
          hover: "var(--table-cell-background-color-hover, #ffe2d44d)",
        },
      },
    },
  },
  singleSelect: {
    row: {
      background: {
        color: {
          default: "var(--single-select-row-background-color-default, #ffffff)",
          hover: "var(--single-select-row-background-color-hover, #fbfbfb)",
        },
      },
    },
    paragraph: "var(--single-select-paragraph, 400 14px/150% var(--Lato))",
    list: {
      border: "var(--single-select-list-border, 1px solid #dbdbdb)",
    },
    borderRadius: "var(--single-select-border-radius, 8px)",
  },
  score: {
    size: {
      jumbo: "var(--score-size-jumbo, 96px)",
      large: "var(--score-size-large, 56px)",
      medium: "var(--score-size-medium, 40px)",
      small: "var(--score-size-small, 32px)",
      xsmall: "var(--score-size-xsmall, 24px)",
    },
  },
  gallery: {
    curtain: {
      color: "var(--gallery-curtain-color, #1e1e1e66)",
    },
    foreground: {
      color: "var(--gallery-foreground-color, #ffffff)",
    },
    height: {
      md: "var(--gallery-height-md, 382px)",
      sm: "var(--gallery-height-sm, 211px)",
    },
    background: {
      color: "var(--gallery-background-color, #ededed)",
    },
    image: {
      height: {
        desktop: "var(--gallery-image-height-desktop, 179px)",
      },
    },
  },
  dropdownMenu: {
    elevation: "var(--dropdown-menu-elevation, 0px 1px 4px 0px rgba(0, 0, 0, 0.1))",
  },
  list: {
    item: {
      height: {
        large: "var(--list-item-height-large, 56px)",
        medium: "var(--list-item-height-medium, 48px)",
        small: "var(--list-item-height-small, 40px)",
      },
    },
    listItem: {
      link: {
        sm: "var(--list-list-item-link-sm, 600 14px/150% var(--Lato))",
        md: "var(--list-list-item-link-md, 600 16px/150% var(--Lato))",
      },
      default: {
        sm: "var(--list-list-item-default-sm, 400 14px/150% var(--Lato))",
        md: "var(--list-list-item-default-md, 400 16px/150% var(--Lato))",
      },
    },
  },
  disclaimer: {
    color: "var(--disclaimer-color, #808080)",
    font: "var(--disclaimer-font, 400 10px/150% var(--Lato))",
  },
  image: {
    borderRadius: "var(--image-border-radius, 8px)",
  },
  alert: {
    positive: {
      foreground: {
        color: "var(--alert-positive-foreground-color, #0c4414)",
      },
      background: {
        color: "var(--alert-positive-background-color, #d2eed6)",
      },
    },
    caution: {
      foreground: {
        color: "var(--alert-caution-foreground-color, #634b14)",
      },
      background: {
        color: "var(--alert-caution-background-color, #fef1d6)",
      },
    },
    info: {
      foreground: {
        color: "var(--alert-info-foreground-color, #0f4966)",
      },
      background: {
        color: "var(--alert-info-background-color, #d4f0ff)",
      },
    },
    error: {
      foreground: {
        color: "var(--alert-error-foreground-color, #5b0f0f)",
      },
      background: {
        color: "var(--alert-error-background-color, #fad4d4)",
      },
    },
  },
  userLogin: {
    container: {
      width: "var(--user-login-container-width, 400px)",
      maxHeight: "var(--user-login-container-max-height, calc(100vh - 2*48px))",
    },
  },
  carouselControl: {
    size: {
      md: "var(--carousel-control-size-md, 40px)",
      sm: "var(--carousel-control-size-sm, 32px)",
    },
  },
  summary: {
    price: {
      font: "var(--summary-price-font, 700 40px/120% var(--Lato))",
    },
  },
  map: {
    borderRadius: "var(--map-border-radius, 8px)",
  },
  drawer: {
    boxShadow: "var(--drawer-box-shadow, 0px -8px 32px 0px rgba(0, 0, 0, 0.1))",
  },
  typography: {
    displayXl: "var(--typography-display-xl, 700 56px/110% var(--Lato))",
    displayLg: "var(--typography-display-lg, 700 48px/110% var(--Lato))",
    heading2Xl: "var(--typography-heading-2-xl, 700 40px/110% var(--Lato))",
    headingXl: "var(--typography-heading-xl, 700 32px/110% var(--Lato))",
    headingLg: "var(--typography-heading-lg, 700 24px/110% var(--Lato))",
    headingMd: "var(--typography-heading-md, 600 20px/110% var(--Lato))",
    headingSm: "var(--typography-heading-sm, 600 18px/110% var(--Lato))",
    headingXs: "var(--typography-heading-xs, 600 16px/110% var(--Lato))",
    heading2Xs: "var(--typography-heading-2-xs, 600 14px/110% var(--Lato))",
    bodyLg: "var(--typography-body-lg, 400 18px/150% var(--Lato))",
    bodyMd: "var(--typography-body-md, 400 16px/150% var(--Lato))",
    bodySm: "var(--typography-body-sm, 400 14px/150% var(--Lato))",
    bodyXs: "var(--typography-body-xs, 400 12px/150% var(--Lato))",
    body2Xs: "var(--typography-body-2-xs, 400 10px/150% var(--Lato))",
    labelMd: "var(--typography-label-md, 600 16px/150% var(--Lato))",
    labelSm: "var(--typography-label-sm, 600 14px/150% var(--Lato))",
    labelXs: "var(--typography-label-xs, 600 12px/150% var(--Lato))",
    linkLg: "var(--typography-link-lg, 600 18px/150% var(--Lato))",
    linkMd: "var(--typography-link-md, 600 16px/150% var(--Lato))",
    linkSm: "var(--typography-link-sm, 600 14px/150% var(--Lato))",
  },
  section: {
    width: {
      full: "var(--section-width-full, 100%)",
      lg: "var(--section-width-lg, 792px)",
    },
  },
  accoCard: {
    image: {
      height: {
        lg: "var(--acco-card-image-height-lg, 211px)",
        md: "var(--acco-card-image-height-md, 162px)",
        sm: "var(--acco-card-image-height-sm, 186px)",
      },
      borderRadius: "var(--acco-card-image-border-radius, 8px)",
      width: {
        default: "var(--acco-card-image-width-default, 100%)",
      },
    },
    width: {
      default: "var(--acco-card-width-default, 100%)",
      md: "var(--acco-card-width-md, 343px)",
      sm: "var(--acco-card-width-sm, 288px)",
      xs: "var(--acco-card-width-xs, 256px)",
    },
  },
  award: {
    backgroundColor: {
      gold: "var(--award-background-color-gold, #fbd684)",
      silver: "var(--award-background-color-silver, #ededed)",
    },
    borderColor: {
      gold: "var(--award-border-color-gold, #f8bb32)",
      silver: "var(--award-border-color-silver, #c9c9c9)",
    },
    foregroundColor: {
      gold: "var(--award-foreground-color-gold, #95701e)",
      silver: "var(--award-foreground-color-silver, #808080)",
    },
    elevation: "var(--award-elevation, 0px 1px 4px 0px rgba(0, 0, 0, 0.1))",
    borderRadius: "var(--award-border-radius, 8px)",
  },
  skeleton: {
    color: "var(--skeleton-color, #ededed)",
  },
  filter: {
    border: {
      color: "var(--filter-border-color, #c9c9c9)",
    },
    background: {
      color: "var(--filter-background-color, #ffffff)",
    },
  },
  tile: {
    yellow: {
      background: {
        color: "var(--tile-yellow-background-color, #fdefcd)",
      },
      foreground: {
        color: "var(--tile-yellow-foreground-color, #614502)",
      },
    },
    purple: {
      background: {
        color: "var(--tile-purple-background-color, #efdaee)",
      },
      foreground: {
        color: "var(--tile-purple-foreground-color, #471d44)",
      },
    },
    green: {
      background: {
        color: "var(--tile-green-background-color, #d2eed6)",
      },
      foreground: {
        color: "var(--tile-green-foreground-color, #0c4414)",
      },
    },
    red: {
      background: {
        color: "var(--tile-red-background-color, #fad4d4)",
      },
      foreground: {
        color: "var(--tile-red-foreground-color, #5b0f0f)",
      },
    },
    orange: {
      background: {
        color: "var(--tile-orange-background-color, #ffe2d4)",
      },
      foreground: {
        color: "var(--tile-orange-foreground-color, #662c0f)",
      },
    },
    blue: {
      background: {
        color: "var(--tile-blue-background-color, #d4f0ff)",
      },
      foreground: {
        color: "var(--tile-blue-foreground-color, #0f4966)",
      },
    },
    borderRadius: "var(--tile-border-radius, 8px)",
  },
  palette: {
    orange: {
      "20": "var(--palette-orange-20, #ffe2d4)",
      "40": "var(--palette-orange-40, #ffc5a8)",
      "60": "var(--palette-orange-60, #ff8c51)",
      "100": "var(--palette-orange-100, #ff6f26)",
      "120": "var(--palette-orange-120, #cc591e)",
      "140": "var(--palette-orange-140, #994317)",
      "160": "var(--palette-orange-160, #662c0f)",
    },
    yellow: {
      "20": "var(--palette-yellow-20, #fef1d6)",
      "40": "var(--palette-yellow-40, #fbd684)",
      "60": "var(--palette-yellow-60, #f9c95b)",
      "100": "var(--palette-yellow-100, #f8bb32)",
      "120": "var(--palette-yellow-120, #c69628)",
      "140": "var(--palette-yellow-140, #95701e)",
      "160": "var(--palette-yellow-160, #634b14)",
    },
    purple: {
      "20": "var(--palette-purple-20, #efdaee)",
      "40": "var(--palette-purple-40, #e0b6dd)",
      "60": "var(--palette-purple-60, #d091cc)",
      "100": "var(--palette-purple-100, #b148aa)",
      "120": "var(--palette-purple-120, #8e3a88)",
      "140": "var(--palette-purple-140, #6a2b66)",
      "160": "var(--palette-purple-160, #471d44)",
    },
    teal: {
      "20": "var(--palette-teal-20, #d8ebe8)",
      "40": "var(--palette-teal-40, #b1d7d1)",
      "60": "var(--palette-teal-60, #8bc3b9)",
      "100": "var(--palette-teal-100, #3d9b8b)",
      "120": "var(--palette-teal-120, #317c6f)",
      "140": "var(--palette-teal-140, #255d53)",
      "160": "var(--palette-teal-160, #183e38)",
    },
    sandYellow: {
      "20": "var(--palette-sand-yellow-20, #fdefcd)",
      "40": "var(--palette-sand-yellow-40, #fade9b)",
      "60": "var(--palette-sand-yellow-60, #f8ce69)",
      "100": "var(--palette-sand-yellow-100, #f3ad05)",
      "120": "var(--palette-sand-yellow-120, #c28a04)",
      "140": "var(--palette-sand-yellow-140, #926803)",
      "160": "var(--palette-sand-yellow-160, #614502)",
    },
    blazeOrange: {
      "20": "var(--palette-blaze-orange-20, #fedfcf)",
      "40": "var(--palette-blaze-orange-40, #febf9f)",
      "60": "var(--palette-blaze-orange-60, #fda06f)",
      "100": "var(--palette-blaze-orange-100, #fc600f)",
      "120": "var(--palette-blaze-orange-120, #ca4d0c)",
      "140": "var(--palette-blaze-orange-140, #973a09)",
      "160": "var(--palette-blaze-orange-160, #652606)",
    },
    carrotOrange: {
      "20": "var(--palette-carrot-orange-20, #fce7d2)",
      "40": "var(--palette-carrot-orange-40, #f8cfa4)",
      "60": "var(--palette-carrot-orange-60, #f5b877)",
      "100": "var(--palette-carrot-orange-100, #ee881c)",
      "120": "var(--palette-carrot-orange-120, #be6d16)",
      "140": "var(--palette-carrot-orange-140, #8f5211)",
      "160": "var(--palette-carrot-orange-160, #5f360b)",
    },
    green: {
      "20": "var(--palette-green-20, #ccf0cc)",
      "40": "var(--palette-green-40, #9ae099)",
      "60": "var(--palette-green-60, #67d166)",
      "100": "var(--palette-green-100, #02b200)",
      "120": "var(--palette-green-120, #028e00)",
      "140": "var(--palette-green-140, #016b00)",
      "160": "var(--palette-green-160, #014700)",
    },
    cardinal: {
      "20": "var(--palette-cardinal-20, #f1d1d8)",
      "40": "var(--palette-cardinal-40, #e3a2b1)",
      "60": "var(--palette-cardinal-60, #d4748b)",
      "100": "var(--palette-cardinal-100, #b8173d)",
      "120": "var(--palette-cardinal-120, #931231)",
      "140": "var(--palette-cardinal-140, #6e0e25)",
      "160": "var(--palette-cardinal-160, #4a0918)",
    },
    neutral: {
      "0": "var(--palette-neutral-0, #ffffff)",
      "5": "var(--palette-neutral-5, #fbfbfb)",
      "10": "var(--palette-neutral-10, #ededed)",
      "20": "var(--palette-neutral-20, #dbdbdb)",
      "30": "var(--palette-neutral-30, #c9c9c9)",
      "40": "var(--palette-neutral-40, #a5a5a5)",
      "50": "var(--palette-neutral-50, #808080)",
      "60": "var(--palette-neutral-60, #4a4a4a)",
      "70": "var(--palette-neutral-70, #2c2c2c)",
      "80": "var(--palette-neutral-80, #1e1e1e)",
      "100": "var(--palette-neutral-100, #000000)",
    },
    semantic: {
      green: {
        "20": "var(--palette-semantic-green-20, #d2eed6)",
        "40": "var(--palette-semantic-green-40, #77cd85)",
        "60": "var(--palette-semantic-green-60, #4abc5c)",
        "100": "var(--palette-semantic-green-100, #1dab33)",
        "120": "var(--palette-semantic-green-120, #178929)",
        "140": "var(--palette-semantic-green-140, #11671f)",
        "160": "var(--palette-semantic-green-160, #0c4414)",
      },
      blue: {
        "20": "var(--palette-semantic-blue-20, #d4f0ff)",
        "40": "var(--palette-semantic-blue-40, #7dd3ff)",
        "60": "var(--palette-semantic-blue-60, #51c5ff)",
        "100": "var(--palette-semantic-blue-100, #26b6ff)",
        "120": "var(--palette-semantic-blue-120, #1e92cc)",
        "140": "var(--palette-semantic-blue-140, #176d99)",
        "160": "var(--palette-semantic-blue-160, #0f4966)",
      },
      red: {
        "20": "var(--palette-semantic-red-20, #fad4d4)",
        "40": "var(--palette-semantic-red-40, #f4a8a8)",
        "60": "var(--palette-semantic-red-60, #e95151)",
        "100": "var(--palette-semantic-red-100, #e42626)",
        "120": "var(--palette-semantic-red-120, #b61e1e)",
        "140": "var(--palette-semantic-red-140, #891717)",
        "160": "var(--palette-semantic-red-160, #5b0f0f)",
      },
      yellow: {
        "20": "var(--palette-semantic-yellow-20, #fef1d6)",
        "40": "var(--palette-semantic-yellow-40, #fbd684)",
        "60": "var(--palette-semantic-yellow-60, #f9c95b)",
        "100": "var(--palette-semantic-yellow-100, #f8bb32)",
        "120": "var(--palette-semantic-yellow-120, #c69628)",
        "140": "var(--palette-semantic-yellow-140, #95701e)",
        "160": "var(--palette-semantic-yellow-160, #634b14)",
      },
    },
  },
  weight: {
    bold: "var(--weight-bold, 700)",
    semibold: "var(--weight-semibold, 600)",
    regular: "var(--weight-regular, 400)",
  },
  lineHeight: {
    spacious: "var(--line-height-spacious, 150%)",
    default: "var(--line-height-default, 120%)",
    narrow: "var(--line-height-narrow, 110%)",
  },
  spacing: {
    jumbo: "var(--spacing-jumbo, 64px)",
    big: "var(--spacing-big, 56px)",
    xxlarge: "var(--spacing-xxlarge, 48px)",
    xlarge: "var(--spacing-xlarge, 40px)",
    large: "var(--spacing-large, 32px)",
    medium: "var(--spacing-medium, 24px)",
    small: "var(--spacing-small, 16px)",
    xsmall: "var(--spacing-xsmall, 12px)",
    xxsmall: "var(--spacing-xxsmall, 8px)",
    tiny: "var(--spacing-tiny, 4px)",
    micro: "var(--spacing-micro, 2px)",
  },
  size: {
    large: "var(--size-large, 56rem)",
    medium: "var(--size-medium, 48rem)",
    small: "var(--size-small, 40rem)",
  },
  border: {
    fat: "var(--border-fat, 4px)",
    normal: "var(--border-normal, 2px)",
    thin: "var(--border-thin, 1px)",
  },
  animation: {
    duration: {
      short: "var(--animation-duration-short, 200)",
      long: "var(--animation-duration-long, 1)",
    },
    delay: {
      quick: "var(--animation-delay-quick, 500)",
      long: "var(--animation-delay-long, 1)",
    },
    curve: {
      ease: "var(--animation-curve-ease, cubic-bezier(.25, .1, .25, 1))",
      linear: "var(--animation-curve-linear, cubic-bezier(0, 0, 1, 1))",
      easeIn: "var(--animation-curve-ease-in, cubic-bezier(.42, 0, 1, 1))",
      easeOut: "var(--animation-curve-ease-out, cubic-bezier(0, 0, .58, 1))",
      easeInOut: "var(--animation-curve-ease-in-out, cubic-bezier(.42, 0, .58, 1))",
      easeInCubic: "var(--animation-curve-ease-in-cubic, cubic-bezier(0.32, 0, 0.67, 0))",
      easeOutCubic: "var(--animation-curve-ease-out-cubic, cubic-bezier(0.33, 1, 0.68, 1))",
      easeInOutCubic: "var(--animation-curve-ease-in-out-cubic, cubic-bezier(0.65, 0, 0.35, 1))",
    },
  },
  decoration: {
    link: "var(--decoration-link, underline)",
    none: "var(--decoration-none, none)",
    strike: "var(--decoration-strike, strikethrough)",
  },
  textAlign: {
    left: "var(--text-align-left, left)",
    center: "var(--text-align-center, center)",
    right: "var(--text-align-right, right)",
  },
  textCase: {
    none: "var(--text-case-none, none)",
    upper: "var(--text-case-upper, uppercase)",
    lower: "var(--text-case-lower, lowercase)",
    capitalize: "var(--text-case-capitalize, capitalize)",
  },
  zIndex: {
    deep: "var(--z-index-deep, -99999)",
    default: "var(--z-index-default, 1)",
    lifted: "var(--z-index-lifted, 100)",
    raised: "var(--z-index-raised, 200)",
    floating: "var(--z-index-floating, 800)",
  },
  fontSize: {
    jumbo: "var(--font-size-jumbo, 56px)",
    big: "var(--font-size-big, 48px)",
    xxLarge: "var(--font-size-xx-large, 40px)",
    xLarge: "var(--font-size-x-large, 32px)",
    large: "var(--font-size-large, 24px)",
    medium: "var(--font-size-medium, 20px)",
    small: "var(--font-size-small, 18px)",
    xSmall: "var(--font-size-x-small, 16px)",
    xxSmall: "var(--font-size-xx-small, 14px)",
    tiny: "var(--font-size-tiny, 12px)",
    micro: "var(--font-size-micro, 10px)",
  },
  container: {
    width: {
      full: "var(--container-width-full, 100%)",
      lg: "var(--container-width-lg, 1200px)",
      md: "var(--container-width-md, 792px)",
    },
  },
  column: {
    width: {
      "1": "var(--column-width-1, 100%)",
      "2": "var(--column-width-2, 50%)",
      "3": "var(--column-width-3, 33%)",
      "4": "var(--column-width-4, 25%)",
    },
  },
};
